import { Ison } from '../../components/characters/codegen/Ison.js';
import { Oligon } from '../../components/characters/codegen/Oligon.js';
import { OligonKentimaMiddle } from '../../components/characters/codegen/OligonKentimaMiddle.js';
import { OligonKentimaBelow } from '../../components/characters/codegen/OligonKentimaBelow.js';
import { OligonKentimaAbove } from '../../components/characters/codegen/OligonKentimaAbove.js';
import { OligonYpsiliRight } from '../../components/characters/codegen/OligonYpsiliRight.js';
import { OligonYpsiliLeft } from '../../components/characters/codegen/OligonYpsiliLeft.js';
import { OligonKentimaYpsiliRight } from '../../components/characters/codegen/OligonKentimaYpsiliRight.js';
import { OligonKentimaYpsiliMiddle } from '../../components/characters/codegen/OligonKentimaYpsiliMiddle.js';
import { OligonDoubleYpsili } from '../../components/characters/codegen/OligonDoubleYpsili.js';
import { OligonKentimataDoubleYpsili } from '../../components/characters/codegen/OligonKentimataDoubleYpsili.js';
import { OligonKentimaDoubleYpsiliRight } from '../../components/characters/codegen/OligonKentimaDoubleYpsiliRight.js';
import { OligonKentimaDoubleYpsiliLeft } from '../../components/characters/codegen/OligonKentimaDoubleYpsiliLeft.js';
import { OligonTripleYpsili } from '../../components/characters/codegen/OligonTripleYpsili.js';
import { OligonKentimataTripleYpsili } from '../../components/characters/codegen/OligonKentimataTripleYpsili.js';
import { OligonKentimaTripleYpsili } from '../../components/characters/codegen/OligonKentimaTripleYpsili.js';
import { OligonIson } from '../../components/characters/codegen/OligonIson.js';
import { OligonApostrofos } from '../../components/characters/codegen/OligonApostrofos.js';
import { OligonYporroi } from '../../components/characters/codegen/OligonYporroi.js';
import { OligonElafron } from '../../components/characters/codegen/OligonElafron.js';
import { OligonElafronApostrofos } from '../../components/characters/codegen/OligonElafronApostrofos.js';
import { OligonChamili } from '../../components/characters/codegen/OligonChamili.js';
import { IsonApostrofos } from '../../components/characters/codegen/IsonApostrofos.js';
import { Apostrofos } from '../../components/characters/codegen/Apostrofos.js';
import { ApostrofosSyndesmos } from '../../components/characters/codegen/ApostrofosSyndesmos.js';
import { Yporroi } from '../../components/characters/codegen/Yporroi.js';
import { Elafron } from '../../components/characters/codegen/Elafron.js';
import { RunningElafron } from '../../components/characters/RunningElafron.js';
import { ElafronApostrofos } from '../../components/characters/codegen/ElafronApostrofos.js';
import { Chamili } from '../../components/characters/codegen/Chamili.js';
import { ChamiliApostrofos } from '../../components/characters/codegen/ChamiliApostrofos.js';
import { ChamiliElafron } from '../../components/characters/codegen/ChamiliElafron.js';
import { ChamiliElafronApostrofos } from '../../components/characters/codegen/ChamiliElafronApostrofos.js';
import { DoubleChamili } from '../../components/characters/codegen/DoubleChamili.js';
import { DoubleChamiliApostrofos } from '../../components/characters/codegen/DoubleChamiliApostrofos.js';
import { DoubleChamiliElafron } from '../../components/characters/codegen/DoubleChamiliElafron.js';
import { DoubleChamiliElafronApostrofos } from '../../components/characters/codegen/DoubleChamiliElafronApostrofos.js';
import { TripleChamili } from '../../components/characters/codegen/TripleChamili.js';
import { PetastiIson } from '../../components/characters/codegen/PetastiIson.js';
import { Petasti } from '../../components/characters/codegen/Petasti.js';
import { PetastiOligon } from '../../components/characters/codegen/PetastiOligon.js';
import { PetastiKentima } from '../../components/characters/codegen/PetastiKentima.js';
import { PetastiYpsiliRight } from '../../components/characters/codegen/PetastiYpsiliRight.js';
import { PetastiYpsiliLeft } from '../../components/characters/codegen/PetastiYpsiliLeft.js';
import { PetastiKentimaYpsiliRight } from '../../components/characters/codegen/PetastiKentimaYpsiliRight.js';
import { PetastiKentimaYpsiliMiddle } from '../../components/characters/codegen/PetastiKentimaYpsiliMiddle.js';
import { PetastiDoubleYpsili } from '../../components/characters/codegen/PetastiDoubleYpsili.js';
import { PetastiKentimataDoubleYpsili } from '../../components/characters/codegen/PetastiKentimataDoubleYpsili.js';
import { PetastiKentimaDoubleYpsiliRight } from '../../components/characters/codegen/PetastiKentimaDoubleYpsiliRight.js';
import { PetastiKentimaDoubleYpsiliLeft } from '../../components/characters/codegen/PetastiKentimaDoubleYpsiliLeft.js';
import { PetastiTripleYpsili } from '../../components/characters/codegen/PetastiTripleYpsili.js';
import { PetastiKentimataTripleYpsili } from '../../components/characters/codegen/PetastiKentimataTripleYpsili.js';
import { PetastiKentimaTripleYpsili } from '../../components/characters/codegen/PetastiKentimaTripleYpsili.js';
import { PetastiApostrofos } from '../../components/characters/codegen/PetastiApostrofos.js';
import { PetastiYporroi } from '../../components/characters/codegen/PetastiYporroi.js';
import { PetastiElafron } from '../../components/characters/codegen/PetastiElafron.js';
import { PetastiRunningElafron } from '../../components/characters/PetastiRunningElafron.js';
import { PetastiElafronApostrofos } from '../../components/characters/codegen/PetastiElafronApostrofos.js';
import { PetastiChamili } from '../../components/characters/codegen/PetastiChamili.js';
import { PetastiChamiliApostrofos } from '../../components/characters/codegen/PetastiChamiliApostrofos.js';
import { PetastiChamiliElafron } from '../../components/characters/codegen/PetastiChamiliElafron.js';
import { PetastiChamiliElafronApostrofos } from '../../components/characters/codegen/PetastiChamiliElafronApostrofos.js';
import { PetastiDoubleChamili } from '../../components/characters/codegen/PetastiDoubleChamili.js';
import { PetastiDoubleChamiliApostrofos } from '../../components/characters/codegen/PetastiDoubleChamiliApostrofos.js';
import { Kentima } from '../../components/characters/codegen/Kentima.js';
import { Kentimata } from '../../components/characters/codegen/Kentimata.js';
import { OligonKentimataBelow } from '../../components/characters/OligonKentimataBelow.js';
import { OligonKentimataAbove } from '../../components/characters/codegen/OligonKentimataAbove.js';
import { OligonIsonKentimata } from '../../components/characters/codegen/OligonIsonKentimata.js';
import { OligonKentimaMiddleKentimata } from '../../components/characters/codegen/OligonKentimaMiddleKentimata.js';
import { OligonYpsiliRightKentimata } from '../../components/characters/codegen/OligonYpsiliRightKentimata.js';
import { OligonYpsiliLeftKentimata } from '../../components/characters/codegen/OligonYpsiliLeftKentimata.js';
import { OligonApostrofosKentimata } from '../../components/characters/codegen/OligonApostrofosKentimata.js';
import { OligonYporroiKentimata } from '../../components/characters/codegen/OligonYporroiKentimata.js';
import { OligonElafronKentimata } from '../../components/characters/codegen/OligonElafronKentimata.js';
import { OligonRunningElafronKentimata } from '../../components/characters/codegen/OligonRunningElafronKentimata.js';
import { OligonElafronApostrofosKentimata } from '../../components/characters/codegen/OligonElafronApostrofosKentimata.js';
import { OligonChamiliKentimata } from '../../components/characters/codegen/OligonChamiliKentimata.js';
import { Vareia } from '../../components/characters/Vareia.js';
import { Psifiston } from '../../components/characters/codegen/Psifiston.js';
import { Antikenoma } from '../../components/characters/Antikenoma.js';
import { Omalon } from '../../components/characters/codegen/Omalon.js';
import { OmalonConnecting } from '../../components/characters/codegen/OmalonConnecting.js';
import { Heteron } from '../../components/characters/codegen/Heteron.js';
import { HeteronConnecting } from '../../components/characters/codegen/HeteronConnecting.js';
import { Endofonon } from '../../components/characters/codegen/Endofonon.js';
import { YfenAbove } from '../../components/characters/codegen/YfenAbove.js';
import { YfenBelow } from '../../components/characters/codegen/YfenBelow.js';
import { Stavros } from '../../components/characters/codegen/Stavros.js';
import { StavrosAbove } from '../../components/characters/codegen/StavrosAbove.js';
import { Breath } from '../../components/characters/codegen/Breath.js';
import { KlasmaAbove } from '../../components/characters/codegen/KlasmaAbove.js';
import { KlasmaBelow } from '../../components/characters/codegen/KlasmaBelow.js';
import { Apli } from '../../components/characters/codegen/Apli.js';
import { Dipli } from '../../components/characters/codegen/Dipli.js';
import { Tripli } from '../../components/characters/codegen/Tripli.js';
import { Tetrapli } from '../../components/characters/codegen/Tetrapli.js';
import { Koronis } from '../../components/characters/codegen/Koronis.js';
import { Leimma1 } from '../../components/characters/codegen/Leimma1.js';
import { Leimma2 } from '../../components/characters/codegen/Leimma2.js';
import { Leimma3 } from '../../components/characters/codegen/Leimma3.js';
import { Leimma4 } from '../../components/characters/codegen/Leimma4.js';
import { LeimmaDot } from '../../components/characters/codegen/LeimmaDot.js';
import { GorgonAbove } from '../../components/characters/codegen/GorgonAbove.js';
import { GorgonBelow } from '../../components/characters/codegen/GorgonBelow.js';
import { GorgonDottedLeft } from '../../components/characters/codegen/GorgonDottedLeft.js';
import { GorgonDottedRight } from '../../components/characters/codegen/GorgonDottedRight.js';
import { Digorgon } from '../../components/characters/codegen/Digorgon.js';
import { DigorgonDottedLeftBelow } from '../../components/characters/codegen/DigorgonDottedLeftBelow.js';
import { DigorgonDottedLeftAbove } from '../../components/characters/codegen/DigorgonDottedLeftAbove.js';
import { DigorgonDottedRight } from '../../components/characters/codegen/DigorgonDottedRight.js';
import { Trigorgon } from '../../components/characters/codegen/Trigorgon.js';
import { TrigorgonDottedLeftBelow } from '../../components/characters/codegen/TrigorgonDottedLeftBelow.js';
import { TrigorgonDottedLeftAbove } from '../../components/characters/codegen/TrigorgonDottedLeftAbove.js';
import { TrigorgonDottedRight } from '../../components/characters/codegen/TrigorgonDottedRight.js';
import { Argon } from '../../components/characters/codegen/Argon.js';
import { Diargon } from '../../components/characters/codegen/Diargon.js';
import { Triargon } from '../../components/characters/codegen/Triargon.js';
import { GorgonSecondary } from '../../components/characters/codegen/GorgonSecondary.js';
import { GorgonDottedLeftSecondary } from '../../components/characters/codegen/GorgonDottedLeftSecondary.js';
import { GorgonDottedRightSecondary } from '../../components/characters/codegen/GorgonDottedRightSecondary.js';
import { DigorgonSecondary } from '../../components/characters/codegen/DigorgonSecondary.js';
import { DigorgonDottedLeftBelowSecondary } from '../../components/characters/codegen/DigorgonDottedLeftBelowSecondary.js';
import { DigorgonDottedRightSecondary } from '../../components/characters/codegen/DigorgonDottedRightSecondary.js';
import { TrigorgonSecondary } from '../../components/characters/codegen/TrigorgonSecondary.js';
import { TrigorgonDottedLeftBelowSecondary } from '../../components/characters/codegen/TrigorgonDottedLeftBelowSecondary.js';
import { TrigorgonDottedRightSecondary } from '../../components/characters/codegen/TrigorgonDottedRightSecondary.js';
import { DigorgonDottedLeftSecondary } from '../../components/characters/codegen/DigorgonDottedLeftSecondary.js';
import { TrigorgonDottedLeftSecondary } from '../../components/characters/codegen/TrigorgonDottedLeftSecondary.js';
import { AgogiPoliArgi } from '../../components/characters/codegen/AgogiPoliArgi.js';
import { AgogiArgoteri } from '../../components/characters/codegen/AgogiArgoteri.js';
import { AgogiArgi } from '../../components/characters/codegen/AgogiArgi.js';
import { AgogiMetria } from '../../components/characters/codegen/AgogiMetria.js';
import { AgogiMesi } from '../../components/characters/codegen/AgogiMesi.js';
import { AgogiGorgi } from '../../components/characters/codegen/AgogiGorgi.js';
import { AgogiGorgoteri } from '../../components/characters/codegen/AgogiGorgoteri.js';
import { AgogiPoliGorgi } from '../../components/characters/codegen/AgogiPoliGorgi.js';
import { AgogiPoliArgiAbove } from '../../components/characters/codegen/AgogiPoliArgiAbove.js';
import { AgogiArgoteriAbove } from '../../components/characters/codegen/AgogiArgoteriAbove.js';
import { AgogiArgiAbove } from '../../components/characters/codegen/AgogiArgiAbove.js';
import { AgogiMetriaAbove } from '../../components/characters/codegen/AgogiMetriaAbove.js';
import { AgogiMesiAbove } from '../../components/characters/codegen/AgogiMesiAbove.js';
import { AgogiGorgiAbove } from '../../components/characters/codegen/AgogiGorgiAbove.js';
import { AgogiGorgoteriAbove } from '../../components/characters/codegen/AgogiGorgoteriAbove.js';
import { AgogiPoliGorgiAbove } from '../../components/characters/codegen/AgogiPoliGorgiAbove.js';
import { MartyriaNoteZoLow } from '../../components/characters/codegen/MartyriaNoteZoLow.js';
import { MartyriaNoteNiLow } from '../../components/characters/codegen/MartyriaNoteNiLow.js';
import { MartyriaNotePaLow } from '../../components/characters/codegen/MartyriaNotePaLow.js';
import { MartyriaNoteVouLow } from '../../components/characters/codegen/MartyriaNoteVouLow.js';
import { MartyriaNoteGaLow } from '../../components/characters/codegen/MartyriaNoteGaLow.js';
import { MartyriaNoteDiLow } from '../../components/characters/codegen/MartyriaNoteDiLow.js';
import { MartyriaNoteKeLow } from '../../components/characters/codegen/MartyriaNoteKeLow.js';
import { MartyriaNoteZo } from '../../components/characters/codegen/MartyriaNoteZo.js';
import { MartyriaNoteNi } from '../../components/characters/codegen/MartyriaNoteNi.js';
import { MartyriaNotePa } from '../../components/characters/codegen/MartyriaNotePa.js';
import { MartyriaNoteVou } from '../../components/characters/codegen/MartyriaNoteVou.js';
import { MartyriaNoteGa } from '../../components/characters/codegen/MartyriaNoteGa.js';
import { MartyriaNoteDi } from '../../components/characters/codegen/MartyriaNoteDi.js';
import { MartyriaNoteKe } from '../../components/characters/codegen/MartyriaNoteKe.js';
import { MartyriaNoteZoHigh } from '../../components/characters/codegen/MartyriaNoteZoHigh.js';
import { MartyriaNoteNiHigh } from '../../components/characters/codegen/MartyriaNoteNiHigh.js';
import { MartyriaNotePaHigh } from '../../components/characters/codegen/MartyriaNotePaHigh.js';
import { MartyriaNoteVouHigh } from '../../components/characters/codegen/MartyriaNoteVouHigh.js';
import { MartyriaNoteGaHigh } from '../../components/characters/codegen/MartyriaNoteGaHigh.js';
import { MartyriaNoteDiHigh } from '../../components/characters/codegen/MartyriaNoteDiHigh.js';
import { MartyriaNoteKeHigh } from '../../components/characters/codegen/MartyriaNoteKeHigh.js';
import { MartyriaTick } from '../../components/characters/codegen/MartyriaTick.js';
import { MartyriaZoBelow } from '../../components/characters/codegen/MartyriaZoBelow.js';
import { MartyriaDeltaBelow } from '../../components/characters/codegen/MartyriaDeltaBelow.js';
import { MartyriaAlphaBelow } from '../../components/characters/codegen/MartyriaAlphaBelow.js';
import { MartyriaLegetosBelow } from '../../components/characters/codegen/MartyriaLegetosBelow.js';
import { MartyriaNanaBelow } from '../../components/characters/codegen/MartyriaNanaBelow.js';
import { MartyriaDeltaDottedBelow } from '../../components/characters/codegen/MartyriaDeltaDottedBelow.js';
import { MartyriaAlphaDottedBelow } from '../../components/characters/codegen/MartyriaAlphaDottedBelow.js';
import { MartyriaHardChromaticPaBelow } from '../../components/characters/codegen/MartyriaHardChromaticPaBelow.js';
import { MartyriaHardChromaticDiBelow } from '../../components/characters/codegen/MartyriaHardChromaticDiBelow.js';
import { MartyriaSoftChromaticDiBelow } from '../../components/characters/codegen/MartyriaSoftChromaticDiBelow.js';
import { MartyriaSoftChromaticKeBelow } from '../../components/characters/codegen/MartyriaSoftChromaticKeBelow.js';
import { MartyriaZygosBelow } from '../../components/characters/codegen/MartyriaZygosBelow.js';
import { MartyriaZoAbove } from '../../components/characters/codegen/MartyriaZoAbove.js';
import { MartyriaDeltaAbove } from '../../components/characters/codegen/MartyriaDeltaAbove.js';
import { MartyriaAlphaAbove } from '../../components/characters/codegen/MartyriaAlphaAbove.js';
import { MartyriaLegetosAbove } from '../../components/characters/codegen/MartyriaLegetosAbove.js';
import { MartyriaNanaAbove } from '../../components/characters/codegen/MartyriaNanaAbove.js';
import { MartyriaDeltaDottedAbove } from '../../components/characters/codegen/MartyriaDeltaDottedAbove.js';
import { MartyriaAlphaDottedAbove } from '../../components/characters/codegen/MartyriaAlphaDottedAbove.js';
import { MartyriaHardChromaticPaAbove } from '../../components/characters/codegen/MartyriaHardChromaticPaAbove.js';
import { MartyriaHardChromaticDiAbove } from '../../components/characters/codegen/MartyriaHardChromaticDiAbove.js';
import { MartyriaSoftChromaticDiAbove } from '../../components/characters/codegen/MartyriaSoftChromaticDiAbove.js';
import { MartyriaSoftChromaticKeAbove } from '../../components/characters/codegen/MartyriaSoftChromaticKeAbove.js';
import { MartyriaZygosAbove } from '../../components/characters/codegen/MartyriaZygosAbove.js';
import { FthoraDiatonicNiLowAbove } from '../../components/characters/codegen/FthoraDiatonicNiLowAbove.js';
import { FthoraDiatonicPaAbove } from '../../components/characters/codegen/FthoraDiatonicPaAbove.js';
import { FthoraDiatonicVouAbove } from '../../components/characters/codegen/FthoraDiatonicVouAbove.js';
import { FthoraDiatonicGaAbove } from '../../components/characters/codegen/FthoraDiatonicGaAbove.js';
import { FthoraDiatonicDiAbove } from '../../components/characters/codegen/FthoraDiatonicDiAbove.js';
import { FthoraDiatonicKeAbove } from '../../components/characters/codegen/FthoraDiatonicKeAbove.js';
import { FthoraDiatonicZoAbove } from '../../components/characters/codegen/FthoraDiatonicZoAbove.js';
import { FthoraDiatonicNiHighAbove } from '../../components/characters/codegen/FthoraDiatonicNiHighAbove.js';
import { FthoraHardChromaticPaAbove } from '../../components/characters/codegen/FthoraHardChromaticPaAbove.js';
import { FthoraHardChromaticDiAbove } from '../../components/characters/codegen/FthoraHardChromaticDiAbove.js';
import { FthoraSoftChromaticDiAbove } from '../../components/characters/codegen/FthoraSoftChromaticDiAbove.js';
import { FthoraSoftChromaticKeAbove } from '../../components/characters/codegen/FthoraSoftChromaticKeAbove.js';
import { FthoraEnharmonicAbove } from '../../components/characters/codegen/FthoraEnharmonicAbove.js';
import { ChroaZygosAbove } from '../../components/characters/codegen/ChroaZygosAbove.js';
import { ChroaKlitonAbove } from '../../components/characters/codegen/ChroaKlitonAbove.js';
import { ChroaSpathiAbove } from '../../components/characters/codegen/ChroaSpathiAbove.js';
import { FthoraDiatonicNiLowSecondary } from '../../components/characters/codegen/FthoraDiatonicNiLowSecondary.js';
import { FthoraDiatonicPaSecondary } from '../../components/characters/codegen/FthoraDiatonicPaSecondary.js';
import { FthoraDiatonicVouSecondary } from '../../components/characters/codegen/FthoraDiatonicVouSecondary.js';
import { FthoraDiatonicGaSecondary } from '../../components/characters/codegen/FthoraDiatonicGaSecondary.js';
import { FthoraDiatonicDiSecondary } from '../../components/characters/codegen/FthoraDiatonicDiSecondary.js';
import { FthoraDiatonicKeSecondary } from '../../components/characters/codegen/FthoraDiatonicKeSecondary.js';
import { FthoraDiatonicZoSecondary } from '../../components/characters/codegen/FthoraDiatonicZoSecondary.js';
import { FthoraDiatonicNiHighSecondary } from '../../components/characters/codegen/FthoraDiatonicNiHighSecondary.js';
import { FthoraHardChromaticPaSecondary } from '../../components/characters/codegen/FthoraHardChromaticPaSecondary.js';
import { FthoraHardChromaticDiSecondary } from '../../components/characters/codegen/FthoraHardChromaticDiSecondary.js';
import { FthoraSoftChromaticDiSecondary } from '../../components/characters/codegen/FthoraSoftChromaticDiSecondary.js';
import { FthoraSoftChromaticKeSecondary } from '../../components/characters/codegen/FthoraSoftChromaticKeSecondary.js';
import { FthoraEnharmonicSecondary } from '../../components/characters/codegen/FthoraEnharmonicSecondary.js';
import { ChroaZygosSecondary } from '../../components/characters/codegen/ChroaZygosSecondary.js';
import { ChroaKlitonSecondary } from '../../components/characters/codegen/ChroaKlitonSecondary.js';
import { ChroaSpathiSecondary } from '../../components/characters/codegen/ChroaSpathiSecondary.js';
import { FthoraDiatonicNiLowTertiary } from '../../components/characters/codegen/FthoraDiatonicNiLowTertiary.js';
import { FthoraDiatonicPaTertiary } from '../../components/characters/codegen/FthoraDiatonicPaTertiary.js';
import { FthoraDiatonicVouTertiary } from '../../components/characters/codegen/FthoraDiatonicVouTertiary.js';
import { FthoraDiatonicGaTertiary } from '../../components/characters/codegen/FthoraDiatonicGaTertiary.js';
import { FthoraDiatonicDiTertiary } from '../../components/characters/codegen/FthoraDiatonicDiTertiary.js';
import { FthoraDiatonicKeTertiary } from '../../components/characters/codegen/FthoraDiatonicKeTertiary.js';
import { FthoraDiatonicZoTertiary } from '../../components/characters/codegen/FthoraDiatonicZoTertiary.js';
import { FthoraDiatonicNiHighTertiary } from '../../components/characters/codegen/FthoraDiatonicNiHighTertiary.js';
import { FthoraHardChromaticPaTertiary } from '../../components/characters/codegen/FthoraHardChromaticPaTertiary.js';
import { FthoraHardChromaticDiTertiary } from '../../components/characters/codegen/FthoraHardChromaticDiTertiary.js';
import { FthoraSoftChromaticDiTertiary } from '../../components/characters/codegen/FthoraSoftChromaticDiTertiary.js';
import { FthoraSoftChromaticKeTertiary } from '../../components/characters/codegen/FthoraSoftChromaticKeTertiary.js';
import { FthoraEnharmonicTertiary } from '../../components/characters/codegen/FthoraEnharmonicTertiary.js';
import { ChroaZygosTertiary } from '../../components/characters/codegen/ChroaZygosTertiary.js';
import { ChroaKlitonTertiary } from '../../components/characters/codegen/ChroaKlitonTertiary.js';
import { ChroaSpathiTertiary } from '../../components/characters/codegen/ChroaSpathiTertiary.js';
import { FthoraDiatonicNiLowBelow } from '../../components/characters/codegen/FthoraDiatonicNiLowBelow.js';
import { FthoraDiatonicPaBelow } from '../../components/characters/codegen/FthoraDiatonicPaBelow.js';
import { FthoraDiatonicVouBelow } from '../../components/characters/codegen/FthoraDiatonicVouBelow.js';
import { FthoraDiatonicGaBelow } from '../../components/characters/codegen/FthoraDiatonicGaBelow.js';
import { FthoraDiatonicDiBelow } from '../../components/characters/codegen/FthoraDiatonicDiBelow.js';
import { FthoraDiatonicKeBelow } from '../../components/characters/codegen/FthoraDiatonicKeBelow.js';
import { FthoraDiatonicZoBelow } from '../../components/characters/codegen/FthoraDiatonicZoBelow.js';
import { FthoraDiatonicNiHighBelow } from '../../components/characters/codegen/FthoraDiatonicNiHighBelow.js';
import { FthoraHardChromaticPaBelow } from '../../components/characters/codegen/FthoraHardChromaticPaBelow.js';
import { FthoraHardChromaticDiBelow } from '../../components/characters/codegen/FthoraHardChromaticDiBelow.js';
import { FthoraSoftChromaticDiBelow } from '../../components/characters/codegen/FthoraSoftChromaticDiBelow.js';
import { FthoraSoftChromaticKeBelow } from '../../components/characters/codegen/FthoraSoftChromaticKeBelow.js';
import { FthoraEnharmonicBelow } from '../../components/characters/codegen/FthoraEnharmonicBelow.js';
import { ChroaZygosBelow } from '../../components/characters/codegen/ChroaZygosBelow.js';
import { ChroaKlitonBelow } from '../../components/characters/codegen/ChroaKlitonBelow.js';
import { ChroaSpathiBelow } from '../../components/characters/codegen/ChroaSpathiBelow.js';
import { Diesis2 } from '../../components/characters/codegen/Diesis2.js';
import { Diesis4 } from '../../components/characters/codegen/Diesis4.js';
import { Diesis6 } from '../../components/characters/codegen/Diesis6.js';
import { Diesis8 } from '../../components/characters/codegen/Diesis8.js';
import { DiesisGenikiAbove } from '../../components/characters/codegen/DiesisGenikiAbove.js';
import { DiesisGenikiBelow } from '../../components/characters/codegen/DiesisGenikiBelow.js';
import { DiesisGenikiSecondary } from '../../components/characters/codegen/DiesisGenikiSecondary.js';
import { DiesisGenikiTertiary } from '../../components/characters/codegen/DiesisGenikiTertiary.js';
import { Yfesis2 } from '../../components/characters/codegen/Yfesis2.js';
import { Yfesis4 } from '../../components/characters/codegen/Yfesis4.js';
import { Yfesis6 } from '../../components/characters/codegen/Yfesis6.js';
import { Yfesis8 } from '../../components/characters/codegen/Yfesis8.js';
import { YfesisGenikiAbove } from '../../components/characters/codegen/YfesisGenikiAbove.js';
import { YfesisGenikiBelow } from '../../components/characters/codegen/YfesisGenikiBelow.js';
import { Diesis2Secondary } from '../../components/characters/codegen/Diesis2Secondary.js';
import { Diesis4Secondary } from '../../components/characters/codegen/Diesis4Secondary.js';
import { Diesis6Secondary } from '../../components/characters/codegen/Diesis6Secondary.js';
import { Diesis8Secondary } from '../../components/characters/codegen/Diesis8Secondary.js';
import { Diesis2Tertiary } from '../../components/characters/codegen/Diesis2Tertiary.js';
import { Diesis4Tertiary } from '../../components/characters/codegen/Diesis4Tertiary.js';
import { Diesis6Tertiary } from '../../components/characters/codegen/Diesis6Tertiary.js';
import { Diesis8Tertiary } from '../../components/characters/codegen/Diesis8Tertiary.js';
import { Yfesis2Secondary } from '../../components/characters/codegen/Yfesis2Secondary.js';
import { Yfesis4Secondary } from '../../components/characters/codegen/Yfesis4Secondary.js';
import { Yfesis6Secondary } from '../../components/characters/codegen/Yfesis6Secondary.js';
import { Yfesis8Secondary } from '../../components/characters/codegen/Yfesis8Secondary.js';
import { Yfesis2Tertiary } from '../../components/characters/codegen/Yfesis2Tertiary.js';
import { Yfesis4Tertiary } from '../../components/characters/codegen/Yfesis4Tertiary.js';
import { Yfesis6Tertiary } from '../../components/characters/codegen/Yfesis6Tertiary.js';
import { Yfesis8Tertiary } from '../../components/characters/codegen/Yfesis8Tertiary.js';
import { YfesisGenikiSecondary } from '../../components/characters/codegen/YfesisGenikiSecondary.js';
import { YfesisGenikiTertiary } from '../../components/characters/codegen/YfesisGenikiTertiary.js';
import { BarlineSingle } from '../../components/characters/codegen/BarlineSingle.js';
import { BarlineDouble } from '../../components/characters/codegen/BarlineDouble.js';
import { BarlineTheseos } from '../../components/characters/codegen/BarlineTheseos.js';
import { BarlineShortSingle } from '../../components/characters/codegen/BarlineShortSingle.js';
import { BarlineShortDouble } from '../../components/characters/codegen/BarlineShortDouble.js';
import { BarlineShortTheseos } from '../../components/characters/codegen/BarlineShortTheseos.js';
import { BarlineSingleAbove } from '../../components/characters/codegen/BarlineSingleAbove.js';
import { BarlineDoubleAbove } from '../../components/characters/codegen/BarlineDoubleAbove.js';
import { BarlineTheseosAbove } from '../../components/characters/codegen/BarlineTheseosAbove.js';
import { BarlineShortSingleAbove } from '../../components/characters/codegen/BarlineShortSingleAbove.js';
import { BarlineShortDoubleAbove } from '../../components/characters/codegen/BarlineShortDoubleAbove.js';
import { BarlineShortTheseosAbove } from '../../components/characters/codegen/BarlineShortTheseosAbove.js';
import { MeasureNumber2 } from '../../components/characters/codegen/MeasureNumber2.js';
import { MeasureNumber3 } from '../../components/characters/codegen/MeasureNumber3.js';
import { MeasureNumber4 } from '../../components/characters/codegen/MeasureNumber4.js';
import { MeasureNumber5 } from '../../components/characters/codegen/MeasureNumber5.js';
import { MeasureNumber6 } from '../../components/characters/codegen/MeasureNumber6.js';
import { MeasureNumber7 } from '../../components/characters/codegen/MeasureNumber7.js';
import { MeasureNumber8 } from '../../components/characters/codegen/MeasureNumber8.js';
import { NoteIndicatorNi } from '../../components/characters/codegen/NoteIndicatorNi.js';
import { NoteIndicatorPa } from '../../components/characters/codegen/NoteIndicatorPa.js';
import { NoteIndicatorVou } from '../../components/characters/codegen/NoteIndicatorVou.js';
import { NoteIndicatorGa } from '../../components/characters/codegen/NoteIndicatorGa.js';
import { NoteIndicatorDi } from '../../components/characters/codegen/NoteIndicatorDi.js';
import { NoteIndicatorKe } from '../../components/characters/codegen/NoteIndicatorKe.js';
import { NoteIndicatorZo } from '../../components/characters/codegen/NoteIndicatorZo.js';
import { IsonIndicatorUnison } from '../../components/characters/codegen/IsonIndicatorUnison.js';
import { IsonIndicatorDiLow } from '../../components/characters/codegen/IsonIndicatorDiLow.js';
import { IsonIndicatorKeLow } from '../../components/characters/codegen/IsonIndicatorKeLow.js';
import { IsonIndicatorZo } from '../../components/characters/codegen/IsonIndicatorZo.js';
import { IsonIndicatorNi } from '../../components/characters/codegen/IsonIndicatorNi.js';
import { IsonIndicatorPa } from '../../components/characters/codegen/IsonIndicatorPa.js';
import { IsonIndicatorVou } from '../../components/characters/codegen/IsonIndicatorVou.js';
import { IsonIndicatorGa } from '../../components/characters/codegen/IsonIndicatorGa.js';
import { IsonIndicatorDi } from '../../components/characters/codegen/IsonIndicatorDi.js';
import { IsonIndicatorKe } from '../../components/characters/codegen/IsonIndicatorKe.js';
import { IsonIndicatorZoHigh } from '../../components/characters/codegen/IsonIndicatorZoHigh.js';
import { Gorthmikon } from '../../components/characters/codegen/Gorthmikon.js';
import { Pelastikon } from '../../components/characters/codegen/Pelastikon.js';
import { ModeFirst } from '../../components/characters/codegen/ModeFirst.js';
import { ModeSecond } from '../../components/characters/codegen/ModeSecond.js';
import { ModeThird } from '../../components/characters/codegen/ModeThird.js';
import { ModeThirdNana } from '../../components/characters/codegen/ModeThirdNana.js';
import { ModeFourth } from '../../components/characters/codegen/ModeFourth.js';
import { ModeLegetos } from '../../components/characters/codegen/ModeLegetos.js';
import { ModePlagalFirst } from '../../components/characters/codegen/ModePlagalFirst.js';
import { ModePlagalSecond } from '../../components/characters/codegen/ModePlagalSecond.js';
import { ModeVarys } from '../../components/characters/codegen/ModeVarys.js';
import { ModeVarys2 } from '../../components/characters/codegen/ModeVarys2.js';
import { ModePlagalFourth } from '../../components/characters/codegen/ModePlagalFourth.js';
import { ModeNi } from '../../components/characters/codegen/ModeNi.js';
import { ModePa } from '../../components/characters/codegen/ModePa.js';
import { ModeVou } from '../../components/characters/codegen/ModeVou.js';
import { ModeGa } from '../../components/characters/codegen/ModeGa.js';
import { ModeDi } from '../../components/characters/codegen/ModeDi.js';
import { ModeKe } from '../../components/characters/codegen/ModeKe.js';
import { ModeZo } from '../../components/characters/codegen/ModeZo.js';
import { ModeOligonKentimaAbove } from '../../components/characters/codegen/ModeOligonKentimaAbove.js';
import { ModeOligonYpsili } from '../../components/characters/codegen/ModeOligonYpsili.js';
import { ModeElafron } from '../../components/characters/codegen/ModeElafron.js';
import { ModeRunningElafron } from '../../components/characters/codegen/ModeRunningElafron.js';
import { ModePlagal } from '../../components/characters/codegen/ModePlagal.js';
import { ModeWordEchos } from '../../components/characters/codegen/ModeWordEchos.js';
import { ModeWordVarys } from '../../components/characters/codegen/ModeWordVarys.js';
import { ModeAlpha } from '../../components/characters/codegen/ModeAlpha.js';
import { ModeBeta } from '../../components/characters/codegen/ModeBeta.js';
import { ModeGamma } from '../../components/characters/codegen/ModeGamma.js';
import { ModeDelta } from '../../components/characters/codegen/ModeDelta.js';
import { ModeAlphaCapital } from '../../components/characters/codegen/ModeAlphaCapital.js';
import { ModeBetaCapital } from '../../components/characters/codegen/ModeBetaCapital.js';
import { ModeGammaCapital } from '../../components/characters/codegen/ModeGammaCapital.js';
import { ModeDeltaCapital } from '../../components/characters/codegen/ModeDeltaCapital.js';

export function defineCustomElementsCharactersBodyCodegen() {
  customElements.define('x-ison', Ison);
  customElements.define('x-oligon', Oligon);
  customElements.define('x-oligon-kentima-middle', OligonKentimaMiddle);
  customElements.define('x-oligon-kentima-below', OligonKentimaBelow);
  customElements.define('x-oligon-kentima-above', OligonKentimaAbove);
  customElements.define('x-oligon-ypsili-right', OligonYpsiliRight);
  customElements.define('x-oligon-ypsili-left', OligonYpsiliLeft);
  customElements.define(
    'x-oligon-kentima-ypsili-right',
    OligonKentimaYpsiliRight,
  );
  customElements.define(
    'x-oligon-kentima-ypsili-middle',
    OligonKentimaYpsiliMiddle,
  );
  customElements.define('x-oligon-double-ypsili', OligonDoubleYpsili);
  customElements.define(
    'x-oligon-kentimata-double-ypsili',
    OligonKentimataDoubleYpsili,
  );
  customElements.define(
    'x-oligon-kentima-double-ypsili-right',
    OligonKentimaDoubleYpsiliRight,
  );
  customElements.define(
    'x-oligon-kentima-double-ypsili-left',
    OligonKentimaDoubleYpsiliLeft,
  );
  customElements.define('x-oligon-triple-ypsili', OligonTripleYpsili);
  customElements.define(
    'x-oligon-kentimata-triple-ypsili',
    OligonKentimataTripleYpsili,
  );
  customElements.define(
    'x-oligon-kentima-triple-ypsili',
    OligonKentimaTripleYpsili,
  );
  customElements.define('x-oligon-ison', OligonIson);
  customElements.define('x-oligon-apostrofos', OligonApostrofos);
  customElements.define('x-oligon-yporroi', OligonYporroi);
  customElements.define('x-oligon-elafron', OligonElafron);
  customElements.define('x-oligon-elafron-apostrofos', OligonElafronApostrofos);
  customElements.define('x-oligon-chamili', OligonChamili);
  customElements.define('x-ison-apostrofos', IsonApostrofos);
  customElements.define('x-apostrofos', Apostrofos);
  customElements.define('x-apostrofos-syndesmos', ApostrofosSyndesmos);
  customElements.define('x-yporroi', Yporroi);
  customElements.define('x-elafron', Elafron);
  customElements.define('x-running-elafron', RunningElafron);
  customElements.define('x-elafron-apostrofos', ElafronApostrofos);
  customElements.define('x-chamili', Chamili);
  customElements.define('x-chamili-apostrofos', ChamiliApostrofos);
  customElements.define('x-chamili-elafron', ChamiliElafron);
  customElements.define(
    'x-chamili-elafron-apostrofos',
    ChamiliElafronApostrofos,
  );
  customElements.define('x-double-chamili', DoubleChamili);
  customElements.define('x-double-chamili-apostrofos', DoubleChamiliApostrofos);
  customElements.define('x-double-chamili-elafron', DoubleChamiliElafron);
  customElements.define(
    'x-double-chamili-elafron-apostrofos',
    DoubleChamiliElafronApostrofos,
  );
  customElements.define('x-triple-chamili', TripleChamili);
  customElements.define('x-petasti-ison', PetastiIson);
  customElements.define('x-petasti', Petasti);
  customElements.define('x-petasti-oligon', PetastiOligon);
  customElements.define('x-petasti-kentima', PetastiKentima);
  customElements.define('x-petasti-ypsili-right', PetastiYpsiliRight);
  customElements.define('x-petasti-ypsili-left', PetastiYpsiliLeft);
  customElements.define(
    'x-petasti-kentima-ypsili-right',
    PetastiKentimaYpsiliRight,
  );
  customElements.define(
    'x-petasti-kentima-ypsili-middle',
    PetastiKentimaYpsiliMiddle,
  );
  customElements.define('x-petasti-double-ypsili', PetastiDoubleYpsili);
  customElements.define(
    'x-petasti-kentimata-double-ypsili',
    PetastiKentimataDoubleYpsili,
  );
  customElements.define(
    'x-petasti-kentima-double-ypsili-right',
    PetastiKentimaDoubleYpsiliRight,
  );
  customElements.define(
    'x-petasti-kentima-double-ypsili-left',
    PetastiKentimaDoubleYpsiliLeft,
  );
  customElements.define('x-petasti-triple-ypsili', PetastiTripleYpsili);
  customElements.define(
    'x-petasti-kentimata-triple-ypsili',
    PetastiKentimataTripleYpsili,
  );
  customElements.define(
    'x-petasti-kentima-triple-ypsili',
    PetastiKentimaTripleYpsili,
  );
  customElements.define('x-petasti-apostrofos', PetastiApostrofos);
  customElements.define('x-petasti-yporroi', PetastiYporroi);
  customElements.define('x-petasti-elafron', PetastiElafron);
  customElements.define('x-petasti-running-elafron', PetastiRunningElafron);
  customElements.define(
    'x-petasti-elafron-apostrofos',
    PetastiElafronApostrofos,
  );
  customElements.define('x-petasti-chamili', PetastiChamili);
  customElements.define(
    'x-petasti-chamili-apostrofos',
    PetastiChamiliApostrofos,
  );
  customElements.define('x-petasti-chamili-elafron', PetastiChamiliElafron);
  customElements.define(
    'x-petasti-chamili-elafron-apostrofos',
    PetastiChamiliElafronApostrofos,
  );
  customElements.define('x-petasti-double-chamili', PetastiDoubleChamili);
  customElements.define(
    'x-petasti-double-chamili-apostrofos',
    PetastiDoubleChamiliApostrofos,
  );
  customElements.define('x-kentima', Kentima);
  customElements.define('x-kentimata', Kentimata);
  customElements.define('x-oligon-kentimata-below', OligonKentimataBelow);
  customElements.define('x-oligon-kentimata-above', OligonKentimataAbove);
  customElements.define('x-oligon-ison-kentimata', OligonIsonKentimata);
  customElements.define(
    'x-oligon-kentima-middle-kentimata',
    OligonKentimaMiddleKentimata,
  );
  customElements.define(
    'x-oligon-ypsili-right-kentimata',
    OligonYpsiliRightKentimata,
  );
  customElements.define(
    'x-oligon-ypsili-left-kentimata',
    OligonYpsiliLeftKentimata,
  );
  customElements.define(
    'x-oligon-apostrofos-kentimata',
    OligonApostrofosKentimata,
  );
  customElements.define('x-oligon-yporroi-kentimata', OligonYporroiKentimata);
  customElements.define('x-oligon-elafron-kentimata', OligonElafronKentimata);
  customElements.define(
    'x-oligon-running-elafron-kentimata',
    OligonRunningElafronKentimata,
  );
  customElements.define(
    'x-oligon-elafron-apostrofos-kentimata',
    OligonElafronApostrofosKentimata,
  );
  customElements.define('x-oligon-chamili-kentimata', OligonChamiliKentimata);

  customElements.define('x-vareia', Vareia);

  customElements.define('x-agogi-poli-argi', AgogiPoliArgi);
  customElements.define('x-agogi-argoteri', AgogiArgoteri);
  customElements.define('x-agogi-argi', AgogiArgi);
  customElements.define('x-agogi-metria', AgogiMetria);
  customElements.define('x-agogi-mesi', AgogiMesi);
  customElements.define('x-agogi-gorgi', AgogiGorgi);
  customElements.define('x-agogi-gorgoteri', AgogiGorgoteri);
  customElements.define('x-agogi-poli-gorgi', AgogiPoliGorgi);

  customElements.define('x-stavros', Stavros);
  customElements.define('x-stavros-above', StavrosAbove);
  customElements.define('x-breath', Breath);

  customElements.define('x-leimma1', Leimma1);
  customElements.define('x-leimma2', Leimma2);
  customElements.define('x-leimma3', Leimma3);
  customElements.define('x-leimma4', Leimma4);

  customElements.define('x-martyria-note-zo-low', MartyriaNoteZoLow);
  customElements.define('x-martyria-note-ni-low', MartyriaNoteNiLow);
  customElements.define('x-martyria-note-pa-low', MartyriaNotePaLow);
  customElements.define('x-martyria-note-vou-low', MartyriaNoteVouLow);
  customElements.define('x-martyria-note-ga-low', MartyriaNoteGaLow);
  customElements.define('x-martyria-note-di-low', MartyriaNoteDiLow);
  customElements.define('x-martyria-note-ke-low', MartyriaNoteKeLow);
  customElements.define('x-martyria-note-zo', MartyriaNoteZo);
  customElements.define('x-martyria-note-ni', MartyriaNoteNi);
  customElements.define('x-martyria-note-pa', MartyriaNotePa);
  customElements.define('x-martyria-note-vou', MartyriaNoteVou);
  customElements.define('x-martyria-note-ga', MartyriaNoteGa);
  customElements.define('x-martyria-note-di', MartyriaNoteDi);
  customElements.define('x-martyria-note-ke', MartyriaNoteKe);
  customElements.define('x-martyria-note-zo-high', MartyriaNoteZoHigh);
  customElements.define('x-martyria-note-ni-high', MartyriaNoteNiHigh);
  customElements.define('x-martyria-note-pa-high', MartyriaNotePaHigh);
  customElements.define('x-martyria-note-vou-high', MartyriaNoteVouHigh);
  customElements.define('x-martyria-note-ga-high', MartyriaNoteGaHigh);
  customElements.define('x-martyria-note-di-high', MartyriaNoteDiHigh);
  customElements.define('x-martyria-note-ke-high', MartyriaNoteKeHigh);
  customElements.define('x-barline-single', BarlineSingle);
  customElements.define('x-barline-double', BarlineDouble);
  customElements.define('x-barline-theseos', BarlineTheseos);
  customElements.define('x-barline-short-single', BarlineShortSingle);
  customElements.define('x-barline-short-double', BarlineShortDouble);
  customElements.define('x-barline-short-theseos', BarlineShortTheseos);
  customElements.define('x-barline-single-above', BarlineSingleAbove);
  customElements.define('x-barline-double-above', BarlineDoubleAbove);
  customElements.define('x-barline-theseos-above', BarlineTheseosAbove);
  customElements.define(
    'x-barline-short-single-above',
    BarlineShortSingleAbove,
  );
  customElements.define(
    'x-barline-short-double-above',
    BarlineShortDoubleAbove,
  );
  customElements.define(
    'x-barline-short-theseos-above',
    BarlineShortTheseosAbove,
  );
  customElements.define('x-gorthmikon', Gorthmikon);
  customElements.define('x-pelastikon', Pelastikon);
  customElements.define('x-mode-first', ModeFirst);
  customElements.define('x-mode-second', ModeSecond);
  customElements.define('x-mode-third', ModeThird);
  customElements.define('x-mode-third-nana', ModeThirdNana);
  customElements.define('x-mode-fourth', ModeFourth);
  customElements.define('x-mode-legetos', ModeLegetos);
  customElements.define('x-mode-plagal-first', ModePlagalFirst);
  customElements.define('x-mode-plagal-second', ModePlagalSecond);
  customElements.define('x-mode-varys', ModeVarys);
  customElements.define('x-mode-varys2', ModeVarys2);
  customElements.define('x-mode-plagal-fourth', ModePlagalFourth);
  customElements.define('x-mode-ni', ModeNi);
  customElements.define('x-mode-pa', ModePa);
  customElements.define('x-mode-vou', ModeVou);
  customElements.define('x-mode-ga', ModeGa);
  customElements.define('x-mode-di', ModeDi);
  customElements.define('x-mode-ke', ModeKe);
  customElements.define('x-mode-zo', ModeZo);
  customElements.define('x-mode-oligon-kentima-above', ModeOligonKentimaAbove);
  customElements.define('x-mode-oligon-ypsili', ModeOligonYpsili);
  customElements.define('x-mode-elafron', ModeElafron);
  customElements.define('x-mode-running-elafron', ModeRunningElafron);
  customElements.define('x-mode-plagal', ModePlagal);
  customElements.define('x-mode-word-echos', ModeWordEchos);
  customElements.define('x-mode-word-varys', ModeWordVarys);
  customElements.define('x-mode-alpha', ModeAlpha);
  customElements.define('x-mode-beta', ModeBeta);
  customElements.define('x-mode-gamma', ModeGamma);
  customElements.define('x-mode-delta', ModeDelta);
  customElements.define('x-mode-alpha-capital', ModeAlphaCapital);
  customElements.define('x-mode-beta-capital', ModeBetaCapital);
  customElements.define('x-mode-gamma-capital', ModeGammaCapital);
  customElements.define('x-mode-delta-capital', ModeDeltaCapital);
}

export function defineCustomElementsCharactersMarkCodegen() {
  customElements.define('x-psifiston', Psifiston);
  customElements.define('x-antikenoma', Antikenoma);
  customElements.define('x-omalon', Omalon);
  customElements.define('x-omalon-connecting', OmalonConnecting);
  customElements.define('x-heteron', Heteron);
  customElements.define('x-heteron-connecting', HeteronConnecting);
  customElements.define('x-endofonon', Endofonon);
  customElements.define('x-yfen-above', YfenAbove);
  customElements.define('x-yfen-below', YfenBelow);
  customElements.define('x-klasma-above', KlasmaAbove);
  customElements.define('x-klasma-below', KlasmaBelow);
  customElements.define('x-apli', Apli);
  customElements.define('x-dipli', Dipli);
  customElements.define('x-tripli', Tripli);
  customElements.define('x-tetrapli', Tetrapli);
  customElements.define('x-koronis', Koronis);
  customElements.define('x-leimma-dot', LeimmaDot);
  customElements.define('x-gorgon-above', GorgonAbove);
  customElements.define('x-gorgon-below', GorgonBelow);
  customElements.define('x-gorgon-dotted-left', GorgonDottedLeft);
  customElements.define('x-gorgon-dotted-right', GorgonDottedRight);
  customElements.define('x-digorgon', Digorgon);
  customElements.define(
    'x-digorgon-dotted-left-below',
    DigorgonDottedLeftBelow,
  );
  customElements.define(
    'x-digorgon-dotted-left-above',
    DigorgonDottedLeftAbove,
  );
  customElements.define('x-digorgon-dotted-right', DigorgonDottedRight);
  customElements.define('x-trigorgon', Trigorgon);
  customElements.define(
    'x-trigorgon-dotted-left-below',
    TrigorgonDottedLeftBelow,
  );
  customElements.define(
    'x-trigorgon-dotted-left-above',
    TrigorgonDottedLeftAbove,
  );
  customElements.define('x-trigorgon-dotted-right', TrigorgonDottedRight);
  customElements.define('x-argon', Argon);
  customElements.define('x-diargon', Diargon);
  customElements.define('x-triargon', Triargon);
  customElements.define('x-gorgon-secondary', GorgonSecondary);
  customElements.define(
    'x-gorgon-dotted-left-secondary',
    GorgonDottedLeftSecondary,
  );
  customElements.define(
    'x-gorgon-dotted-right-secondary',
    GorgonDottedRightSecondary,
  );
  customElements.define('x-digorgon-secondary', DigorgonSecondary);
  customElements.define(
    'x-digorgon-dotted-left-below-secondary',
    DigorgonDottedLeftBelowSecondary,
  );
  customElements.define(
    'x-digorgon-dotted-right-secondary',
    DigorgonDottedRightSecondary,
  );
  customElements.define('x-trigorgon-secondary', TrigorgonSecondary);
  customElements.define(
    'x-trigorgon-dotted-left-below-secondary',
    TrigorgonDottedLeftBelowSecondary,
  );
  customElements.define(
    'x-trigorgon-dotted-right-secondary',
    TrigorgonDottedRightSecondary,
  );
  customElements.define(
    'x-digorgon-dotted-left-secondary',
    DigorgonDottedLeftSecondary,
  );
  customElements.define(
    'x-trigorgon-dotted-left-secondary',
    TrigorgonDottedLeftSecondary,
  );

  customElements.define('x-agogi-poli-argi-above', AgogiPoliArgiAbove);
  customElements.define('x-agogi-argoteri-above', AgogiArgoteriAbove);
  customElements.define('x-agogi-argi-above', AgogiArgiAbove);
  customElements.define('x-agogi-metria-above', AgogiMetriaAbove);
  customElements.define('x-agogi-mesi-above', AgogiMesiAbove);
  customElements.define('x-agogi-gorgi-above', AgogiGorgiAbove);
  customElements.define('x-agogi-gorgoteri-above', AgogiGorgoteriAbove);
  customElements.define('x-agogi-poli-gorgi-above', AgogiPoliGorgiAbove);

  customElements.define('x-martyria-tick', MartyriaTick);
  customElements.define('x-martyria-zo-below', MartyriaZoBelow);
  customElements.define('x-martyria-delta-below', MartyriaDeltaBelow);
  customElements.define('x-martyria-alpha-below', MartyriaAlphaBelow);
  customElements.define('x-martyria-legetos-below', MartyriaLegetosBelow);
  customElements.define('x-martyria-nana-below', MartyriaNanaBelow);
  customElements.define(
    'x-martyria-delta-dotted-below',
    MartyriaDeltaDottedBelow,
  );
  customElements.define(
    'x-martyria-alpha-dotted-below',
    MartyriaAlphaDottedBelow,
  );
  customElements.define(
    'x-martyria-hard-chromatic-pa-below',
    MartyriaHardChromaticPaBelow,
  );
  customElements.define(
    'x-martyria-hard-chromatic-di-below',
    MartyriaHardChromaticDiBelow,
  );
  customElements.define(
    'x-martyria-soft-chromatic-di-below',
    MartyriaSoftChromaticDiBelow,
  );
  customElements.define(
    'x-martyria-soft-chromatic-ke-below',
    MartyriaSoftChromaticKeBelow,
  );
  customElements.define('x-martyria-zygos-below', MartyriaZygosBelow);
  customElements.define('x-martyria-zo-above', MartyriaZoAbove);
  customElements.define('x-martyria-delta-above', MartyriaDeltaAbove);
  customElements.define('x-martyria-alpha-above', MartyriaAlphaAbove);
  customElements.define('x-martyria-legetos-above', MartyriaLegetosAbove);
  customElements.define('x-martyria-nana-above', MartyriaNanaAbove);
  customElements.define(
    'x-martyria-delta-dotted-above',
    MartyriaDeltaDottedAbove,
  );
  customElements.define(
    'x-martyria-alpha-dotted-above',
    MartyriaAlphaDottedAbove,
  );
  customElements.define(
    'x-martyria-hard-chromatic-pa-above',
    MartyriaHardChromaticPaAbove,
  );
  customElements.define(
    'x-martyria-hard-chromatic-di-above',
    MartyriaHardChromaticDiAbove,
  );
  customElements.define(
    'x-martyria-soft-chromatic-di-above',
    MartyriaSoftChromaticDiAbove,
  );
  customElements.define(
    'x-martyria-soft-chromatic-ke-above',
    MartyriaSoftChromaticKeAbove,
  );
  customElements.define('x-martyria-zygos-above', MartyriaZygosAbove);
  customElements.define(
    'x-fthora-diatonic-ni-low-above',
    FthoraDiatonicNiLowAbove,
  );
  customElements.define('x-fthora-diatonic-pa-above', FthoraDiatonicPaAbove);
  customElements.define('x-fthora-diatonic-vou-above', FthoraDiatonicVouAbove);
  customElements.define('x-fthora-diatonic-ga-above', FthoraDiatonicGaAbove);
  customElements.define('x-fthora-diatonic-di-above', FthoraDiatonicDiAbove);
  customElements.define('x-fthora-diatonic-ke-above', FthoraDiatonicKeAbove);
  customElements.define('x-fthora-diatonic-zo-above', FthoraDiatonicZoAbove);
  customElements.define(
    'x-fthora-diatonic-ni-high-above',
    FthoraDiatonicNiHighAbove,
  );
  customElements.define(
    'x-fthora-hard-chromatic-pa-above',
    FthoraHardChromaticPaAbove,
  );
  customElements.define(
    'x-fthora-hard-chromatic-di-above',
    FthoraHardChromaticDiAbove,
  );
  customElements.define(
    'x-fthora-soft-chromatic-di-above',
    FthoraSoftChromaticDiAbove,
  );
  customElements.define(
    'x-fthora-soft-chromatic-ke-above',
    FthoraSoftChromaticKeAbove,
  );
  customElements.define('x-fthora-enharmonic-above', FthoraEnharmonicAbove);
  customElements.define('x-chroa-zygos-above', ChroaZygosAbove);
  customElements.define('x-chroa-kliton-above', ChroaKlitonAbove);
  customElements.define('x-chroa-spathi-above', ChroaSpathiAbove);
  customElements.define(
    'x-fthora-diatonic-ni-low-secondary',
    FthoraDiatonicNiLowSecondary,
  );
  customElements.define(
    'x-fthora-diatonic-pa-secondary',
    FthoraDiatonicPaSecondary,
  );
  customElements.define(
    'x-fthora-diatonic-vou-secondary',
    FthoraDiatonicVouSecondary,
  );
  customElements.define(
    'x-fthora-diatonic-ga-secondary',
    FthoraDiatonicGaSecondary,
  );
  customElements.define(
    'x-fthora-diatonic-di-secondary',
    FthoraDiatonicDiSecondary,
  );
  customElements.define(
    'x-fthora-diatonic-ke-secondary',
    FthoraDiatonicKeSecondary,
  );
  customElements.define(
    'x-fthora-diatonic-zo-secondary',
    FthoraDiatonicZoSecondary,
  );
  customElements.define(
    'x-fthora-diatonic-ni-high-secondary',
    FthoraDiatonicNiHighSecondary,
  );
  customElements.define(
    'x-fthora-hard-chromatic-pa-secondary',
    FthoraHardChromaticPaSecondary,
  );
  customElements.define(
    'x-fthora-hard-chromatic-di-secondary',
    FthoraHardChromaticDiSecondary,
  );
  customElements.define(
    'x-fthora-soft-chromatic-di-secondary',
    FthoraSoftChromaticDiSecondary,
  );
  customElements.define(
    'x-fthora-soft-chromatic-ke-secondary',
    FthoraSoftChromaticKeSecondary,
  );
  customElements.define(
    'x-fthora-enharmonic-secondary',
    FthoraEnharmonicSecondary,
  );
  customElements.define('x-chroa-zygos-secondary', ChroaZygosSecondary);
  customElements.define('x-chroa-kliton-secondary', ChroaKlitonSecondary);
  customElements.define('x-chroa-spathi-secondary', ChroaSpathiSecondary);
  customElements.define(
    'x-fthora-diatonic-ni-low-tertiary',
    FthoraDiatonicNiLowTertiary,
  );
  customElements.define(
    'x-fthora-diatonic-pa-tertiary',
    FthoraDiatonicPaTertiary,
  );
  customElements.define(
    'x-fthora-diatonic-vou-tertiary',
    FthoraDiatonicVouTertiary,
  );
  customElements.define(
    'x-fthora-diatonic-ga-tertiary',
    FthoraDiatonicGaTertiary,
  );
  customElements.define(
    'x-fthora-diatonic-di-tertiary',
    FthoraDiatonicDiTertiary,
  );
  customElements.define(
    'x-fthora-diatonic-ke-tertiary',
    FthoraDiatonicKeTertiary,
  );
  customElements.define(
    'x-fthora-diatonic-zo-tertiary',
    FthoraDiatonicZoTertiary,
  );
  customElements.define(
    'x-fthora-diatonic-ni-high-tertiary',
    FthoraDiatonicNiHighTertiary,
  );
  customElements.define(
    'x-fthora-hard-chromatic-pa-tertiary',
    FthoraHardChromaticPaTertiary,
  );
  customElements.define(
    'x-fthora-hard-chromatic-di-tertiary',
    FthoraHardChromaticDiTertiary,
  );
  customElements.define(
    'x-fthora-soft-chromatic-di-tertiary',
    FthoraSoftChromaticDiTertiary,
  );
  customElements.define(
    'x-fthora-soft-chromatic-ke-tertiary',
    FthoraSoftChromaticKeTertiary,
  );
  customElements.define(
    'x-fthora-enharmonic-tertiary',
    FthoraEnharmonicTertiary,
  );
  customElements.define('x-chroa-zygos-tertiary', ChroaZygosTertiary);
  customElements.define('x-chroa-kliton-tertiary', ChroaKlitonTertiary);
  customElements.define('x-chroa-spathi-tertiary', ChroaSpathiTertiary);
  customElements.define(
    'x-fthora-diatonic-ni-low-below',
    FthoraDiatonicNiLowBelow,
  );
  customElements.define('x-fthora-diatonic-pa-below', FthoraDiatonicPaBelow);
  customElements.define('x-fthora-diatonic-vou-below', FthoraDiatonicVouBelow);
  customElements.define('x-fthora-diatonic-ga-below', FthoraDiatonicGaBelow);
  customElements.define('x-fthora-diatonic-di-below', FthoraDiatonicDiBelow);
  customElements.define('x-fthora-diatonic-ke-below', FthoraDiatonicKeBelow);
  customElements.define('x-fthora-diatonic-zo-below', FthoraDiatonicZoBelow);
  customElements.define(
    'x-fthora-diatonic-ni-high-below',
    FthoraDiatonicNiHighBelow,
  );
  customElements.define(
    'x-fthora-hard-chromatic-pa-below',
    FthoraHardChromaticPaBelow,
  );
  customElements.define(
    'x-fthora-hard-chromatic-di-below',
    FthoraHardChromaticDiBelow,
  );
  customElements.define(
    'x-fthora-soft-chromatic-di-below',
    FthoraSoftChromaticDiBelow,
  );
  customElements.define(
    'x-fthora-soft-chromatic-ke-below',
    FthoraSoftChromaticKeBelow,
  );
  customElements.define('x-fthora-enharmonic-below', FthoraEnharmonicBelow);
  customElements.define('x-chroa-zygos-below', ChroaZygosBelow);
  customElements.define('x-chroa-kliton-below', ChroaKlitonBelow);
  customElements.define('x-chroa-spathi-below', ChroaSpathiBelow);
  customElements.define('x-diesis-2', Diesis2);
  customElements.define('x-diesis-4', Diesis4);
  customElements.define('x-diesis-6', Diesis6);
  customElements.define('x-diesis-8', Diesis8);
  customElements.define('x-diesis-geniki-above', DiesisGenikiAbove);
  customElements.define('x-diesis-geniki-below', DiesisGenikiBelow);
  customElements.define('x-diesis-geniki-secondary', DiesisGenikiSecondary);
  customElements.define('x-diesis-geniki-tertiary', DiesisGenikiTertiary);
  customElements.define('x-yfesis-2', Yfesis2);
  customElements.define('x-yfesis-4', Yfesis4);
  customElements.define('x-yfesis-6', Yfesis6);
  customElements.define('x-yfesis-8', Yfesis8);
  customElements.define('x-yfesis-geniki-above', YfesisGenikiAbove);
  customElements.define('x-yfesis-geniki-below', YfesisGenikiBelow);
  customElements.define('x-diesis-2-secondary', Diesis2Secondary);
  customElements.define('x-diesis-4-secondary', Diesis4Secondary);
  customElements.define('x-diesis-6-secondary', Diesis6Secondary);
  customElements.define('x-diesis-8-secondary', Diesis8Secondary);
  customElements.define('x-diesis-2-tertiary', Diesis2Tertiary);
  customElements.define('x-diesis-4-tertiary', Diesis4Tertiary);
  customElements.define('x-diesis-6-tertiary', Diesis6Tertiary);
  customElements.define('x-diesis-8-tertiary', Diesis8Tertiary);
  customElements.define('x-yfesis-2-secondary', Yfesis2Secondary);
  customElements.define('x-yfesis-4-secondary', Yfesis4Secondary);
  customElements.define('x-yfesis-6-secondary', Yfesis6Secondary);
  customElements.define('x-yfesis-8-secondary', Yfesis8Secondary);
  customElements.define('x-yfesis-2-tertiary', Yfesis2Tertiary);
  customElements.define('x-yfesis-4-tertiary', Yfesis4Tertiary);
  customElements.define('x-yfesis-6-tertiary', Yfesis6Tertiary);
  customElements.define('x-yfesis-8-tertiary', Yfesis8Tertiary);
  customElements.define('x-yfesis-geniki-secondary', YfesisGenikiSecondary);
  customElements.define('x-yfesis-geniki-tertiary', YfesisGenikiTertiary);

  customElements.define('x-measure-number-2', MeasureNumber2);
  customElements.define('x-measure-number-3', MeasureNumber3);
  customElements.define('x-measure-number-4', MeasureNumber4);
  customElements.define('x-measure-number-5', MeasureNumber5);
  customElements.define('x-measure-number-6', MeasureNumber6);
  customElements.define('x-measure-number-7', MeasureNumber7);
  customElements.define('x-measure-number-8', MeasureNumber8);
  customElements.define('x-note-indicator-ni', NoteIndicatorNi);
  customElements.define('x-note-indicator-pa', NoteIndicatorPa);
  customElements.define('x-note-indicator-vou', NoteIndicatorVou);
  customElements.define('x-note-indicator-ga', NoteIndicatorGa);
  customElements.define('x-note-indicator-di', NoteIndicatorDi);
  customElements.define('x-note-indicator-ke', NoteIndicatorKe);
  customElements.define('x-note-indicator-zo', NoteIndicatorZo);
  customElements.define('x-ison-indicator-unison', IsonIndicatorUnison);
  customElements.define('x-ison-indicator-di-low', IsonIndicatorDiLow);
  customElements.define('x-ison-indicator-ke-low', IsonIndicatorKeLow);
  customElements.define('x-ison-indicator-zo', IsonIndicatorZo);
  customElements.define('x-ison-indicator-ni', IsonIndicatorNi);
  customElements.define('x-ison-indicator-pa', IsonIndicatorPa);
  customElements.define('x-ison-indicator-vou', IsonIndicatorVou);
  customElements.define('x-ison-indicator-ga', IsonIndicatorGa);
  customElements.define('x-ison-indicator-di', IsonIndicatorDi);
  customElements.define('x-ison-indicator-ke', IsonIndicatorKe);
  customElements.define('x-ison-indicator-zo-high', IsonIndicatorZoHigh);
}
